// this is also part of the MUI virtualization code
import { useEffect, useRef } from 'react'
import { type VariableSizeList } from 'react-window'

export function useResetCache(data: any) {
  const ref = useRef<VariableSizeList>(null)
  useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true)
    }
  }, [data])
  return ref
}
